<template>
    <Head title="Unfiled Redemptions" />
    <div class="py-2 md:py-4 relative">
        <UnfiledRedemptions />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import UnfiledRedemptions from '@/components/trips/unfiled-redemptions.vue';
</script>
